import { z } from 'zod'

export enum ContactFormCategory {
  'Properties' = 'Properties',
  'Rooms' = 'Rooms',
  'Rates' = 'Rates',
  'Packages' = 'Packages',
  'Activities & Products' = 'Activities & Products',
  'Add-ons' = 'Add-ons',
  'Cancellation and Tax Policies' = 'Cancellation and Tax Policies',
  'DNS' = 'DNS',
  'Payment Integration' = 'Payment Integration',
  'Other' = 'Other',
  'Booking & Cancellations' = 'Booking & Cancellations',
}

export const contactFormSchema = z.object({
  name: z.string().trim().min(1, { error: 'val.required' }),
  email: z.email(),
  category: z.enum(ContactFormCategory),
  subject: z.string().trim().min(1, { error: 'val.required' }),
  description: z.string().trim().min(1, { error: 'val.required' }),
  attachment: z.string().optional(),
})

export type ContactFormValues = z.infer<typeof contactFormSchema>
